import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Queries, Mutations } from '../../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber, TimePicker } from 'antd'
import moment from 'moment'
import FromInput from '../../../../../components/user/from/Input'
import detail from '../../../ChildEducationFee/detail'
import {
   changeFormatdate,
   changeFormatFulldate,
 } from "../../../../../utils/formatdate";
 

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
    { label: 'ใบรับรองแพทย์', value: 'ใบรับรองแพทย์' },
   //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

const newsDataProfile = '';
const format = 'HH:mm';

class Tab7 extends Component {
	state = {
        dataTalbeUploads: [
			{
				documentType: null,
            description:null,
				attachFile:null,
            statusFile:false
			},
		],
      columns: [
         {
            title: 'ลำดับ',
            dataIndex: 'sort',
            vertical:'top',
      align:'center',
            render: (item, record, index) => {
               return(
                  <>
                      {this.state.pageData.offset + index + 1}
                  </>
               )
            }
      },
         {
            title: 'วันที่ดำเนินรายการ',
            dataIndex: 'documentType',
            align:'center',
           // width:'200px',
            vertical:'top',
            render: (item, record, index) => {
               return(
                  <>
                      {this.props.detailForm?.studyHistory[index]?.studyHistoryActionDatetime ?
                           <span>{changeFormatFulldate(this.props.detailForm?.studyHistory[index]?.studyHistoryActionDatetime)}</span>
                         // " dsd"
                           : ""}
                    
                  </>
               )
            }
         },
         {
               title: 'ผู้ดำเนินรายการ',
               dataIndex: 'description',
               vertical:'top',
               //width:'200px',
         align:'center',
               render: (item, record, index) => {
                  return(
                     <>
                         {this.props.detailForm?.studyHistory[index]?.studyHistoryActionBy ? 
                          this.props.detailForm?.studyHistory[index]?.studyHistoryActionBy : ""}
                      
                     </>
                  )
               }
         },
         {
               title: 'สถานะ',
               dataIndex: '7',
               //width:'200px',
               vertical:'top',
               align:'center',
               render: (item, record, index) => {
                  return (
                     <>
                      {this.props.detailForm?.studyHistory[index]?.studyHistoryStatus ? 
                          this.props.detailForm?.studyHistory[index]?.studyHistoryStatus : ""}
                      
                     </>
                  )
               }
         },
         {
            title: 'ดำเนินการ',
            dataIndex: '8',
            width:'200px',
            vertical:'top',
            align:'center',
            render: (item, record, index) => {
               return (
                  <>
                   {this.props.detailForm?.studyHistory[index]?.studyHistoryAction ? 
                          this.props.detailForm?.studyHistory[index]?.studyHistoryAction : ""}
                      
                  </>
               )
            }
      },
      {
         title: 'หมายเหตุ',
         dataIndex: '9',
        width:'200px',
         vertical:'top',
         align:'center',
         render: (item, record, index) => {
            return (
               <>
               {this.props.detailForm?.studyHistory[index]?.studyHistoryRemark ? 
this.props.detailForm?.studyHistory[index]?.studyHistoryRemark  : "-"}
                    
               </>
            )
         }
   },
      ],
      dataTalbeLength:1,
      preLoadOnsubmit: false,
      pageData: {
         offset: 0,
         limit: 10,
       },
    }

  dateFormatNumber = (values) => {
    let valueReturn = this.props.form.getFieldValue(values);
    return changeFormatdate(moment(valueReturn));
  };

    showDetailBtnInput = (record, arrayId) =>{
        const { dataTalbeUploads } = this.state
        return(
            <>
                {
                    dataTalbeUploads.length > 1 ? 
                            <Avatar 
                                shape="square"  
                                icon={<Icon type="delete" />} 
                                className="mr-1 mb-1 bg-red"  
                                // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                style={{ cursor: 'pointer', background:"red" }}
                            />
                    : 
                        <Avatar 
                            shape="square"  
                            icon={<Icon type="delete" />} 
                            className="mr-1 mb-1 bg-red"  
                            // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                            style={{ cursor: 'not-allowed' }}
                            disabled={true}
                        />
                }
            </>
        )
    }

	render() {
		const { match ,detailForm } = this.props
        const { getFieldDecorator } = this.props.form
        const { columns, 
            preLoadOnsubmit, 
            dataTalbeUploads, } = this.state

        // console.log('dataTalbeUploads',leaveDayAllData)

		return (
            <Row gutter={16} type="flex" justify="left" align="top" >
            <Col xs={24} md={24} className="pt-0">
                <strong className="color-red">
                    ประวัติการดำเนินการ
                </strong>
            </Col>

           
                                       
                                       <Col xs={24} md={24} align={"right"} className="pt-4">
                                          <Table
                                                columns={columns}
                                                dataSource={detailForm?.studyHistory}
                                                className="mb-3"
                                                bordered
                                                rowCount={detailForm?.studyHistory?.length}
                                                locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                               // pagination={{ defaultPageSize: 5,}}
                                               pagination={false}
                                                scroll={{ x: "max-content" }}
                                          />
                                          
                                       </Col>
                                                  
        </Row>



		)
	}
}

Tab7.defaultProps = {
	autoFocus: false
}
Tab7.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedTab7 = Form.create()(Tab7)

export default withApollo(WrappedTab7)